import { createIcon } from '@chakra-ui/react';

export const TrashBinIcon = createIcon({
  displayName: 'TrashBinIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M14.2118 4.74708C11.9168 4.51547 9.60067 4.39966 7.29509 4.39966C5.92648 4.39966 4.55786 4.47335 3.19978 4.61021L1.78906 4.74708"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.58887 4.05291L5.73626 3.14752C5.84153 2.4948 5.92575 2 7.09433 2H8.90511C10.0737 2 10.1579 2.51586 10.2632 3.14752L10.4106 4.04239"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7282 4.8313L12.2754 11.7796C12.2018 12.864 12.1386 13.7062 10.212 13.7062H5.77981C3.85323 13.7062 3.79005 12.864 3.71636 11.7796L3.26367 4.8313"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
